import { ssrSafeClientFactory } from '../ui/react/bindings/StytchSSRProxy.mjs';
import { StytchB2BClient } from './StytchB2BClient.mjs';

/**
 * Creates a Headless Stytch client object to call the stytch B2B APIs.
 * The Stytch client is not available serverside.
 * @example
 * const stytch = createStytchB2BClient('public-token-<find yours in the stytch dashboard>')
 *
 * return (
 *   <StytchB2BProvider stytch={stytch}>
 *     <App />
 *   </StytchB2BProvider>
 * )
 * @returns A {@link StytchB2BClient}
 */ const createStytchB2BClient = ssrSafeClientFactory(StytchB2BClient);
/**
 * @deprecated Use {createStytchB2BClient()} instead
 */ const createStytchB2BHeadlessClient = createStytchB2BClient;
/**
 * @deprecated Use {StytchB2BClient()} instead
 */ const StytchB2BHeadlessClient = StytchB2BClient;

export { StytchB2BClient, StytchB2BHeadlessClient, createStytchB2BClient, createStytchB2BHeadlessClient };
//# sourceMappingURL=index.headless.mjs.map
